import React from 'react';
import { Auth, I18n } from 'aws-amplify';
import {
  AuthPiece,
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  ButtonRow,
  MessageRow,
  Link,
  Checkbox
} from 'aws-amplify-react';
import LogoArea from './logoarea.js';
import getLatestTermVer from '../util/getLatestTermVer.js';
import {authConfig} from '../../configures/awsConfig.js'
import axios from 'axios';
import {SESSION_INIT_URL} from '../../configures/val.js'
import QueryStrUtil from '../util/queryStrUtil.js';
const myQueryStrUtil = new QueryStrUtil();

export default class ReagreeTermDocs extends AuthPiece {
  constructor (props) {
    super(props);
    this.state = {
      buttonIsDisabled: true,
    };
    this.inputs = {};
    this._validAuthStates = ['reagreeTermsDocs'];
  }
  handleInputChange(evt) {
    this.inputs = this.inputs || {};
    const { name, value, type, checked } = evt.target;
    const check_type = ['radio', 'checkbox'].includes(type);
    this.inputs[name] = check_type? checked : value;
    this.inputs['checkedValue'] = check_type? value: null;
    this.setState({
      buttonIsDisabled: !this.inputs.is_agree
    });
  }
  moveGrandArch = (user) => {
    const clientId = authConfig.userPoolWebClientId;
    const refreshToken = user.signInUserSession.refreshToken.token;
    // state は GrandARCH 側の csrf 検証に使っています
    window.location.href = myQueryStrUtil.getParamContent('callback')+'?client_id='+clientId+'&refresh_token='+refreshToken+'&state='+myQueryStrUtil.getParamContent('state');
    return;
  }
  async makeSession(user) {
    const config = {
      headers: {
        'Content-Type': 'plain/text',
      },
      withCredentials: true,
    };
    const urlStr = SESSION_INIT_URL+'client_id='+authConfig.userPoolWebClientId+'&refresh_token='+user.signInUserSession.refreshToken.token;
    try {
      await axios.get(urlStr, config);
    } catch (err) {
      console.log('makeSession ERROR');
      console.log(err);
    }
    // app=grandarch のときは GrandARCH へ遷移する
    if (myQueryStrUtil.getParamContent('app').includes('grandarch')) {
      this.moveGrandArch(user);
      return;
    }
    // toパラメータにARCHログイン画面URLが含まれていればそこに遷移する
    if (myQueryStrUtil.getParamContent('to').includes('megasolar') ||
        myQueryStrUtil.getParamContent('to').includes('login') ||
        myQueryStrUtil.getParamContent('to').includes('wind')
    ) {
      window.location.href = myQueryStrUtil.getParamContent('to');
      return;
    }
    // 遷移先がパスされている場合はその遷移先に行く
    if (this.props.hasOwnProperty('authData')) {
      if (this.props.authData.hasOwnProperty('href')) {
        window.location.href = this.props.authData.href;
        return;
      }
    }
    this.changeState('signedIn', user);
    return;
  }

  async moveSignedIn(that) {
    const param = {
      "custom:agreed_term": getLatestTermVer(),
    }
    let user;
    try {
      user = await Auth.currentAuthenticatedUser();
    } catch (err) {
      if (err === 'not authenticated') {
        // 有効なtokenがなさそうなので再ログイン
        try {
          user = await Auth.signIn(this.props.authData.username, this.props.authData.pw);
        } catch (signInErr) {
          console.log('signInErr');
          console.log(signInErr);
          return;
        }
      } else {
        alert(I18n.get('Please logout, and re-login'));
        return;
      }
    }
    try {
      await Auth.updateUserAttributes(user, param);
      await Auth.userAttributes(user);
    } catch (err) {
      alert(I18n.get('Please logout, and re-login'));
      return;
    }
    this.makeSession(user);
    this.setState({
      buttonIsDisabled: true
    });
    return;
  }
  callDebug = () => {
    console.log('props');
    console.log(this.props);
  }
  showComponent(theme) {
    const that = this;
    return (
      <div className="loginContainer">
        <LogoArea theme={theme} />
        <FormSection theme={theme}>
          <SectionHeader theme={theme}>
            {I18n.get('Reagree to Terms of Service')}
          </SectionHeader>
          <SectionBody theme={theme}>
            <div className="fontSizeSmall colNatural01">
              <MessageRow>{I18n.get('Terms of Service is updated. If you continue to use this service, please reconfirm Terms of Service.')}</MessageRow>
            </div>
            <div className="loginCheckbox">
              <label className="loginCheckboxText">
                <Checkbox
                  theme={theme}
                  name="is_agree"
                  onChange={this.handleInputChange}
                />
              </label>
            </div>
            <span className="tosMarginRight">
              <Link target="_blank" rel="noreferrer noopener" href={I18n.get('https://www.lapsys.co.jp/english/policy/laplace_id.html')}>{I18n.get('Terms of service')}</Link>
            </span>
            <span className="colNatural01">{I18n.get('I read the Terms of service and agree to its contents.')}</span>
            <ButtonRow style={theme.loginLargeButton} onClick={() => this.moveSignedIn(that)} theme={theme} disabled={this.state.buttonIsDisabled} >
              {I18n.get('Continue')}
            </ButtonRow>
          </SectionBody>
          <SectionFooter theme={theme} />
        </FormSection>
      </div>
    );
  }
}
